import './checkmark.style.sass';
import template from './checkmark.tpl.pug';

class CheckmarkController {
    toggle() {
        this.$ctrl.$setViewValue(!this.selected);
        this.$ctrl.$render();
    }
}

export default {
    selector: 'dbACheckmark',
    template: template(),
    controller: CheckmarkController,
    require: {
        $ctrl: 'ngModel'
    },
    bindings: {
        selected: '<ngModel',
        color: '<',
        loading: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/checkmark/checkmark.cmpt.js